// extracted by mini-css-extract-plugin
export default {"inter":"\"Inter\",sans-serif","poppins":"\"Poppins\",sans-serif","roboto":"\"Roboto\",sans-serif"};